import React from 'react';
import Snackbar from '../Snackbar/Snackbar';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import { translate } from '../../i18n/translate';

export default function ReconnectingNotification() {
  const roomState = useRoomState();

  return (
    <Snackbar
      variant="error"
      headline={translate('reconnecting.header') as string}
      message={translate('reconnecting.message') as string}
      open={roomState === 'reconnecting'}
    />
  );
}
